import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface SectionBadgeProps {
    children: ReactNode
    className?: string
}

export const SectionBadge: FC<SectionBadgeProps> = ({ children, className }): ReactNode => {
    return (
        <span className={cn('inline-flex items-center rounded-full bg-sage px-3.5 py-1.5 text-[14px] font-medium text-ink/90', className)}>
            {children}
        </span>
    )
}
